export const adjusters = [
  {
    id: 1,
    name: '염선무',
    image: '/adjuster/adjuster1.png',
    region: '전국',
    strength: '#손해사정사 선임권 #실손보험 #배상책임',
    registrationNumber: 'BD00002991',
    trainingCompleted: true,
    introduction:
      '안녕하세요. 손해사정사 염선무입니다. 손해사정사 선임권은 보험민원 해결을 위해 금융당국이 도입한 제도 입니다. 현명한 선임권 권리를 잊지말고 행사하세요!!',
    consultingHours: '상담평일 : 09:00~ 18:00',
    career: `현) 올받음손해사정(주) 손해사정사
    전) 라이나생명 디지털사업팀 차장
    한양대학교 행정학과 졸업
    금융해설사 / 투자자산운용사`,
    certification: '신체손해사정사',
  },
  {
    id: 2,
    name: '황인규',
    image: '/adjuster/adjuster4.png',
    region: '서울/경기/인천',
    strength: '#손해사정사 선임권 #화재 #재물보험 #누수 #배상책임 #후유장해 #상해 #질병',
    registrationNumber: '6000000133',
    trainingCompleted: true,
    introduction: `2002년부터 손해사정 업무를 시작하여 DB CSI손해사정(주)에서 조사, 심사팀장 등을 역임하며 배상책임과
    화재,  재물 등의 수많은 보험 사고를 처리하였으며 독립손해사정사로서서 상해,  질병에 관한 손해사정 업무 처리
    진행하고 있습니다.`,
    consultingHours: '평일 : 09:00~ 18:00',
    career: `(현) 올받음손해사정(주) 파트너 손해사정사
    (전) 손해사정 실무 경력 (2005년 5월~)
    (전) DB 손해보험 자회사 재직`,
    certification: '1종손해사정사',
  },
  {
    id: 3,
    name: '장유라',
    image: '/adjuster/adjuster5.png',
    region: '전국',
    strength: '#손해사정사 선임권 #실손보험',
    registrationNumber: 'BD00003642',
    trainingCompleted: true,
    introduction: `안녕하세요
    보험소비자를 위한 보험금 보상 전문 행정사로서  
    금융감독원에 정식 등록된 장유라 손해사정사입니다.
    "손해사정사 직접 선임권 제도" 및  각종 보험금 보상 관련 
    고객이 권리위에 잠자는 자가 되어 보호받지 못하는 일 없도록 
    신뢰를 바탕으로 항상 최선을 다하겠습니다.`,
    consultingHours: '평일 : 09:00~ 18:00',
    career: `현) 장유라행정사사무소 대표
    현) 한국시험행정사회 사무차장 역임중
    현) 올받음손해사정(주) 파트너 손해사정사
    전) 독립손해사정 법인 근무 경력`,
    certification: '신체손해사정사',
  },
  {
    id: 4,
    name: '남궁재선',
    image: '/adjuster/adjuster11.png',
    region: '서울/수도권',
    strength: '#손해사정사 선임권 #실손보험',
    registrationNumber: 'BD00003773',
    trainingCompleted: true,
    introduction: `법률과 보험 약관/ 상품 분야에 대한 깊은 이해와 경험을 바탕으로 고객님들께 최상의 서비스를 제공하고자 합니다.
    보험금 지급 청구와 관련된 다양한 사례를 분석하고, 공정하고 정확한 손해사정을 통해 고객님들의 권리를 보호하는 데
    최선을 다할 것입니다. 항상 성실하고 전문적인 자세로 임하겠습니다`,
    consultingHours: '평일 : 09:00~ 18:00',
    career: `(현) 올받음손해사정(주) 파트너 손해사정사
    전) 보험사 설계사 교육매니저`,
    certification: '신체손해사정사',
  },
  {
    id: 5,
    name: '안준용',
    image: '/adjuster/adjuster3.png',
    region: '서울/경기',
    strength:
      '#손해사정사 선임권 #실손보험 #여성형 여유증 실손보험금 전액지급 #일반암 #진단금 #교통사고',
    registrationNumber: 'BD00003634',
    trainingCompleted: true,
    introduction:
      '안녕하세요 올받음 파트너 손해사정사 안준용입니다. 피보험자 분께서 가입 하신 보험에서 정당한 보상을 받을 수 있도록 최선을 다해 도움을 드릴 수 있도록 노력하겠습니다.',
    consultingHours: '상담평일 : 09:00~ 18:00',
    career: '(현) 올받음손해사정(주) 파트너 손해사정사',
    certification: '신체손해사정사',
  },
  {
    id: 6,
    name: '조강희',
    image: '/adjuster/adjuster2.png',
    region: '대전/충청',
    strength:
      '#손해사정사 선임권 #실손보험 #배상책임 #백내장 입원 보험금 전액 지급 #고지의무 확인 사고 다수 처리 #진단금',
    registrationNumber: 'BD00002692',
    trainingCompleted: true,
    introduction:
      '안녕하세요, 조강희 손해사정사입니다. 공직출신 행정사로서 현재 송파경찰서 정문옆에서 행정사,법무사사무실 운영중입니다. 2020.9. 제43회 신체손해사정사 합격후 2021.6.15.금감원에 신체손해사정사 등록했으며, 현재 ㈜올받음 손해사정에서 재물 및 신체손해사정업무 담당하고 있습니다.',
    consultingHours: '평일 : 09:00~ 18:00',
    career: `(현) 올받음손해사정(주) 책임 손해사정사
    (현) 조강희 행정사 사무소 대표행정사
    (전) (주)천지손해사정 재물 및 신체 총괄 상무이사
    (전) 경기도청 법제담당관실 행정심판 담당업무`,
    certification: `신체손해사정사
    행정사`,
  },
  {
    id: 7,
    name: '양순규',
    image: '/adjuster/adjuster7.png',
    region: '전국',
    strength: '#손해사정사 선임권 #실손보험 #교통사고 #후유장해 #진단금',
    registrationNumber: 'BD00002675',
    trainingCompleted: true,
    introduction: `보험소비자를 위한 보험금 보상 전문가 양순규 손해사정사입니다.
    손해사정사 선임권 사건 뿐만 아니라 상해, 질병, 사망, 후유장해, 진단금, 교통사고, 근재(산재)보상에 
    이르는 다양한 보험금 보상 경험을 토대로 보험소비자에게 늘 정성을 다하겠습니다`,
    consultingHours: '평일 : 09:00~ 18:00',
    career: `(현) 올받음손해사정(주) 파트너 손해사정사
    (전) 정성손해사정 대표
    (전) (주)에이플러스에셋어드바이져 손해사정 업무`,
    certification: '신체손해사정사',
  },
  {
    id: 8,
    name: '김은선',
    image: '/adjuster/adjuster8.png',
    region: '경기남부',
    strength:
      '강점#손해사정사 선임권 #질병보험 #배상책임 #암 진단비 #뇌,심혈관질환 관련 진단금 #교통사고분야',
    registrationNumber: 'BD00000812',
    trainingCompleted: true,
    introduction: `고객을 위한 손해사정으로 질병(암,뇌,심 진단비), 배상책임(교통사고, 일상배상 등)을 전문분야로 
    방사선사로서 의무기록지 판독가능`,
    consultingHours: '상담시평일 : 09:00~ 18:00',
    career: `(현) 올받음손해사정(주) 파트너 손해사정사
    (현) 한국손해사정사회 정회원
    (전) 한국손해사정사회 경기지부 지부장
    (전) 방사선사`,
    certification: `신체손해사정사
    방사선사`,
  },
  {
    id: 9,
    name: '이명진',
    image: '/adjuster/adjuster6.png',
    region: '대구/부산/경남/경북',
    strength: '#손해사정사 선임권 #실손보험',
    registrationNumber: 'BD00002685',
    trainingCompleted: true,
    introduction: `신체 손해사정사 이명진입니다.
보험 소비자 여러분의 정당한 권리를 놓치는 일이 없도록, 보상관련 다양한 노하우를 바탕으로
최고의 보상 서비스를 제공해 드리겠습니다`,
    consultingHours: '평일 : 09:00~ 18:00',
    career: `(현) 올받음손해사정(주) 파트너 손해사정사`,
    certification: '신체손해사정사',
  },
  {
    id: 10,
    name: '이성열',
    image: '/adjuster/adjuster10.png',
    region: '서울/경기북부',
    strength: '#손해사정사 선임권 #실손보험 #배상책임 #후유장해 #상해질병 #진단비 #교통사고',
    registrationNumber: 'BD00003088',
    trainingCompleted: true,
    introduction: `
    보험 계약은 복잡한 법률과 약관 해석이 필요한 전문적인 영역입니다.
    저는 손해사정사로서 다년간의 실무 경험을 통해 보험 약관과 관련 법률을 정확히 분석하고,
    공정한 손해사정을 수행해왔습니다.
    보험 사고 발생 시, 보험사는 자사 이익을 우선할 수밖에 없으며, 이에 따라 피보험자의 정당한 권리가 충분히 보장되지
    못하는 경우도 발생합니다.
    저는 의뢰인이 불이익을 받지 않도록 철저한 검토와 객관적인 손해 평가를 제공하며, 정당한 보상을 받을 수 있도록
    끝까지 함께하겠습니다.`,
    consultingHours: '평일 : 09:00~ 18:00',
    career: `(현) 올받음손해사정(주) 파트너 손해사정사
    전) 포유법률사무소 
    전) 탑손해사정
    동국대학교 법무대학원 석사과정`,
    certification: '신체손해사정사',
  },
  {
    id: 11,
    name: '이성식',
    image: '/adjuster/adjuster9.png',
    region: '전국',
    strength: '#손해사정사 선임권 #실손보험 #상해보험 #질병보험 #배상책임',
    registrationNumber: 'BD00003618',
    trainingCompleted: true,
    introduction: `이성식 손해사정사입니다.
어렵게 알아보시고 의뢰 주시는 것을 잘 알고 있기에 
올바른 보험금이 지급되도록 진심을 다하고 있습니다`,
    consultingHours: '평일 : 09:00~ 18:00',
    career: `(현) 올받음손해사정(주) 파트너 손해사정사
    전) 신한생명 GA사업본부 근무
    전) 코오롱 인더스트리 근무
    한양대학교 섬유공학과 졸업`,
    certification: '신체손해사정사',
  },
  {
    id: 12,
    name: '최유진',
    image: '/adjuster/adjuster12.png',
    region: '전국',
    strength: '#손해사정사 선임권 #실손보험',
    registrationNumber: 'BD-00003931',
    trainingCompleted: false,
    introduction: `소비자 선임권 및 유료 선임 전국 상담 가능
    `,
    consultingHours: '평일 : 09:00~ 18:00',
    career: `(현) 올받음손해사정
   (전) 마포구청 재직 15년
   (전) 사회복지사 직업상담사`,
    certification: `신체손해사정사
    행정사 자격증`,
  },
];
